// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** apk下载链接 POST /api/index/download_app */
export async function postApiIndexDownloadApp(
  body: API.DownloadAppParams,
  options?: { [key: string]: any },
) {
  return request<API.DownloadAppResult>('/api/index/download_app', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取app菜单 POST /api/index/get_app_menu */
export async function postApiIndexGetAppMenu(
  body: API.GetAppMenuParams,
  options?: { [key: string]: any },
) {
  return request<API.GetAppMenuResult>('/api/index/get_app_menu', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 热更新 POST /api/index/upgrade */
export async function postApiIndexUpgrade(
  body: API.UpgradeParams,
  options?: { [key: string]: any },
) {
  return request<API.UpgradeResult>('/api/index/upgrade', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** web菜单 POST /backend/role/get_web_menus */
export async function postBackendRoleGetWebMenus(
  body: API.GetWebMenusParams,
  options?: { [key: string]: any },
) {
  return request<API.GetWebMenusResult>('/backend/role/get_web_menus', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
